import React from 'react'

const ErrorPage = () => {
  return (
    <div>
      <h1>Oops! Something went wrong.</h1>
      <p>We apologize for the inconvenience. Please try again later.</p>
    </div>
  )
}

export default ErrorPage
